var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEyeShow = function SvgEyeShow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-422.000000, -162.000000)",
    fill: "#0B0E12",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410,142 C414.62072,142 418.541031,145.34237 420,150.000021 C418.541031,154.65763 414.62072,158 410,158 C405.37928,158 401.458969,154.657672 400,150.000021 C401.458969,145.34237 405.37928,142 410,142 Z M410,144.666687 C407.238554,144.666687 405,147.054478 405,150.000021 C405,152.945522 407.238554,155.333354 410,155.333354 C412.761446,155.333354 415,152.94548 415,150.000021 C415,147.054478 412.761446,144.666687 410,144.666687 Z M411.767761,148.114409 C412.744067,149.155801 412.744067,150.844241 411.767761,151.885633 C410.791456,152.927025 409.208544,152.927025 408.232239,151.885633 C407.255933,150.844241 407.255933,149.155801 408.232239,148.114409 C409.208544,147.073016 410.791456,147.073016 411.767761,148.114409 Z",
    id: "eye-show"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeShow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-show.1b4bf197.svg";
export { ForwardRef as ReactComponent };